{
  "title": "Fee payment",
  "subTitle": "Select a non-registered account to withdraw fees from",
  "currentAccount": "(current account)"
}
